import Network from '../network.js'

export default {
  fetch(request) {
    return Network.get('prospects/interests', request, true)
  }
}
